import { cn } from './cn.js';

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse bg-slate-100 rounded-md', className)} />;
}

const COL_WIDTHS = ['w-36', 'w-28', 'w-16', 'w-24'];

export function TableSkeleton({ rows = 4, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm">
      <div className="bg-slate-50/80 border-b border-slate-100 h-11" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 px-5 py-4 border-b border-slate-50 last:border-0">
          {Array.from({ length: cols }).map((_, j) => (
            <Skeleton key={j} className={cn('h-4', COL_WIDTHS[j] ?? 'w-20')} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function DetailSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100 shadow-sm">
      <div className="bg-slate-50/60 border-b border-slate-100 h-16" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center justify-between px-5 py-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-4 w-44" />
        </div>
      ))}
    </div>
  );
}
